export const PDF_FALLBACK_TOKEN_KEY = 'PDF_FALLBACK_TOKEN';

export enum EPAGEMODES {
  HTTP_ERROR = 'HTTP_ERROR',
  NOT_PDF = 'NOT_PDF',
}
